/** analytics: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "onVersion": "on {v}",
  "ofPlayers": "of {n} player | of {n} players",
  "pctUnit": "{pct} % {unit}",
  "openStatus": "Open these players in Players →",
  "unlocated": "{n} player without a location is not on the map. Set it in Players → Edit. | {n} players without a location are not on the map. Set it in Players → Edit.",
  "nPlayers": "{n} player | {n} players",
  "nPlays": "{n} play | {n} plays",
  "onScreenX": "· {t} on screen",
  "min": "{n} min",
  "hMin": "{h} h {m} min",
  "chartAria": "Errors and warnings per day, {n} in total",
  "tip": "{e} errors · {w} warnings",
  "today": "Today",
  "d7": "7 days",
  "d30": "30 days",
  "thisMonth": "This month",
  "custom": "Custom",
  "connectivity": "Online now",
  "connectivityHint": "Paired players that sent a heartbeat in the last 30 seconds.",
  "contentSync": "Up to date",
  "latestPublish": "playing the latest publish",
  "syncHint": "Players whose last heartbeat shows the newest published content playing.",
  "latestApp": "On the newest app",
  "noVersions": "no versions reported yet",
  "appHint": "Players running the newest app version any of your players reports.",
  "online": "Online",
  "onlineHint": "Heartbeat in the last 30 seconds.",
  "offline": "Offline",
  "offlineHint": "Paired, but silent for more than 30 seconds.",
  "waiting": "Waiting for first contact",
  "waitingHint": "Paired, but no heartbeat has arrived yet.",
  "notPaired": "Not paired",
  "notPairedHint": "No device is paired to this player seat.",
  "inSync": "In sync",
  "inSyncHint": "Playing the newest published content.",
  "downloading": "Downloading",
  "downloadingHint": "Fetching the newest content; still plays the previous one.",
  "outOfSync": "Out of sync",
  "outOfSyncHint": "Playing older content and not downloading the new one.",
  "unknown": "Unknown",
  "unknownHint": "Not paired, or no recent heartbeat to tell.",
  "title": "Analytics",
  "liveTitle": "Statuses refresh every 30 seconds",
  "live": "Live",
  "intro": "How your players are doing, and what they played.",
  "period": "Period",
  "from": "From",
  "to": "To",
  "retry": "Retry",
  "dateOrder": "Choose a start date on or before the end date.",
  "loading": "Loading analytics…",
  "noPlayers": "No players yet",
  "noPlayersHint": "Once a player is paired, its connectivity, sync, errors and plays show up here.",
  "pairFirst": "Pair your first player",
  "overview": "Overview",
  "noPaired": "No paired players yet",
  "filterStatus": "Filter by status",
  "allPlayers": "All players",
  "syncLabel": "Sync:",
  "players": "Players",
  "locations": "Player locations",
  "noMatch": "No players match these filters.",
  "errorsWarnings": "Errors and warnings",
  "mostErrors": "Players with most errors",
  "mostWarnings": "Players with most warnings",
  "noErrors": "No players with errors in this period.",
  "noWarnings": "No players with warnings in this period.",
  "player": "Player",
  "errors": "Errors",
  "warnings": "Warnings",
  "location": "Location",
  "status": "Status",
  "whatPlayed": "What played",
  "content": "Content",
  "plays": "Plays",
  "onScreen": "On screen",
  "campaign": "Campaign",
  "media": "Media",
  "nothingPlayed": "Nothing played in this period (or the players haven't uploaded their play logs yet).",
  "noErrorsWarnings": "No errors or warnings in this period.",
  "perDay": "Errors and warnings per day",
  "day": "Day"
};
const ar: typeof en = {
  "onVersion": "على {v}",
  "ofPlayers": "من {n} مشغل | من مشغل واحد | من مشغلين | من {n} مشغلات | من {n} مشغلًا | من {n} مشغل",
  "pctUnit": "{pct}٪ {unit}",
  "openStatus": "فتح هذه المشغلات في صفحة المشغلات ←",
  "unlocated": "لا مشغلات بلا موقع. | مشغل واحد بلا موقع غير ظاهر على الخريطة. حدّده في المشغلات ← تعديل. | مشغلان بلا موقع غير ظاهرين على الخريطة. حدّده في المشغلات ← تعديل. | {n} مشغلات بلا موقع غير ظاهرة على الخريطة. حدّده في المشغلات ← تعديل. | {n} مشغلًا بلا موقع غير ظاهر على الخريطة. حدّده في المشغلات ← تعديل. | {n} مشغل بلا موقع غير ظاهر على الخريطة. حدّده في المشغلات ← تعديل.",
  "nPlayers": "لا مشغلات | مشغل واحد | مشغلان | {n} مشغلات | {n} مشغلًا | {n} مشغل",
  "nPlays": "لا مرات تشغيل | مرة تشغيل واحدة | مرتا تشغيل | {n} مرات تشغيل | {n} مرة تشغيل | {n} مرة تشغيل",
  "onScreenX": "· {t} على الشاشة",
  "min": "{n} د",
  "hMin": "{h} س {m} د",
  "chartAria": "الأخطاء والتحذيرات يوميًا، {n} إجمالًا",
  "tip": "{e} أخطاء · {w} تحذيرات",
  "today": "اليوم",
  "d7": "٧ أيام",
  "d30": "٣٠ يومًا",
  "thisMonth": "هذا الشهر",
  "custom": "مخصص",
  "connectivity": "متصل الآن",
  "connectivityHint": "المشغلات المقترنة التي أرسلت نبضًا خلال آخر ٣٠ ثانية.",
  "contentSync": "محدّث",
  "latestPublish": "تعرض أحدث نشر",
  "syncHint": "المشغلات التي يُظهر آخر نبض لها عرض أحدث محتوى منشور.",
  "latestApp": "على أحدث تطبيق",
  "noVersions": "لم تُبلَّغ إصدارات بعد",
  "appHint": "المشغلات التي تعمل بأحدث إصدار للتطبيق أبلغت عنه مشغلاتك.",
  "online": "متصل",
  "onlineHint": "نبض خلال آخر ٣٠ ثانية.",
  "offline": "غير متصل",
  "offlineHint": "مقترن، لكنه صامت لأكثر من ٣٠ ثانية.",
  "waiting": "بانتظار أول اتصال",
  "waitingHint": "مقترن، لكن لم يصل أي نبض بعد.",
  "notPaired": "غير مقترن",
  "notPairedHint": "لا يوجد جهاز مقترن بمقعد المشغل هذا.",
  "inSync": "متزامن",
  "inSyncHint": "يعرض أحدث محتوى منشور.",
  "downloading": "جارٍ التنزيل",
  "downloadingHint": "يجلب أحدث محتوى؛ وما زال يعرض السابق.",
  "outOfSync": "غير متزامن",
  "outOfSyncHint": "يعرض محتوى أقدم ولا ينزّل الجديد.",
  "unknown": "غير معروف",
  "unknownHint": "غير مقترن، أو لا يوجد نبض حديث لمعرفة ذلك.",
  "title": "التحليلات",
  "liveTitle": "تتحدث الحالات كل ٣٠ ثانية",
  "live": "مباشر",
  "intro": "أحوال مشغلاتك، وما عرضته.",
  "period": "الفترة",
  "from": "من",
  "to": "إلى",
  "retry": "إعادة المحاولة",
  "dateOrder": "اختر تاريخ بداية في تاريخ النهاية أو قبله.",
  "loading": "جارٍ تحميل التحليلات…",
  "noPlayers": "لا توجد مشغلات بعد",
  "noPlayersHint": "بمجرد إقران مشغل، يظهر هنا اتصاله ومزامنته وأخطاؤه ومرات تشغيله.",
  "pairFirst": "أقرن أول مشغل",
  "overview": "نظرة عامة",
  "noPaired": "لا توجد مشغلات مقترنة بعد",
  "filterStatus": "التصفية حسب الحالة",
  "allPlayers": "كل المشغلات",
  "syncLabel": "المزامنة:",
  "players": "المشغلات",
  "locations": "مواقع المشغلات",
  "noMatch": "لا توجد مشغلات تطابق هذه المرشحات.",
  "errorsWarnings": "الأخطاء والتحذيرات",
  "mostErrors": "المشغلات الأكثر أخطاءً",
  "mostWarnings": "المشغلات الأكثر تحذيرات",
  "noErrors": "لا توجد مشغلات بها أخطاء في هذه الفترة.",
  "noWarnings": "لا توجد مشغلات بها تحذيرات في هذه الفترة.",
  "player": "المشغل",
  "errors": "الأخطاء",
  "warnings": "التحذيرات",
  "location": "الموقع",
  "status": "الحالة",
  "whatPlayed": "ما عُرض",
  "content": "المحتوى",
  "plays": "مرات التشغيل",
  "onScreen": "على الشاشة",
  "campaign": "حملة",
  "media": "وسائط",
  "nothingPlayed": "لم يُعرض شيء في هذه الفترة (أو لم ترفع المشغلات سجلات التشغيل بعد).",
  "noErrorsWarnings": "لا توجد أخطاء أو تحذيرات في هذه الفترة.",
  "perDay": "الأخطاء والتحذيرات يوميًا",
  "day": "اليوم"
};
export default { en, ar };
